<div *ngIf="quality && scheme" class="sustainable-input" [class.compact]="compact">
  <div *ngIf="!compact; else compactToggle" class="checkbox flex-center-distributed">
    <div>
      <input
        type="checkbox"
        class="ios"
        id="{{ name }}"
        [disabled]="disabled"
        [ngModel]="quality.sustainable"
        (ngModelChange)="toggle($event)"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
    <label for="{{ name }}" class="grow">{{
      "ORDER_FORM.PRODUCT.SUSTAINABLE" | translate
    }}</label>
  </div>
  <ng-template #compactToggle>
    <label class="compact-toggle small">
      <input
        type="checkbox"
        id="{{ name }}"
        [disabled]="disabled"
        [ngModel]="quality.sustainable"
        (ngModelChange)="toggle($event)"
        [ngModelOptions]="{ standalone: true }"
      />
      {{ "ORDER_FORM.PRODUCT.SUSTAINABLE" | translate }}
    </label>
  </ng-template>
  <div class="scheme" *ngIf="quality.sustainable">
    <label *ngIf="!compact" class="control-label">{{ scheme.name }}</label>
    <!-- selectize toma las opciones sólo al inicializarse: se recrea al cambiar el producto -->
    <selectize
      *ngFor="let p of [product]"
      type="product"
      [class]="compact ? 'selectize-sm selectize-small-items' : ''"
      [options]="options"
      [placeholder]="scheme.name"
      [disabled]="disabled"
      [(ngModel)]="quality.sustainable_schemes"
      [ngModelOptions]="{ standalone: true }"
    ></selectize>
  </div>
</div>
